const strings = {
  nl: {
    pairTitle: 'Koppel dit scherm',
    pairStep1: 'Ga in de TB-cast portal naar Schermen → Scherm toevoegen',
    pairStep2: 'Voer deze code in of scan de QR-code',
    pairExpires: 'Code verloopt over {min} min',
    pairPaired: 'Gekoppeld! Content wordt geladen…',
    pairOffline: 'Geen internetverbinding. We proberen het opnieuw…',
    licenseTitle: 'Licentie verlopen',
    licenseText: 'Neem contact op met uw beheerder.',
    licenseUnlicensed: 'Dit scherm heeft geen actieve licentie.',
    noContent: 'Nog geen content toegewezen',
    noContentText: 'Wijs in de portal een playlist, layout of planning toe aan dit scherm.',
    loading: 'Content laden…',
    syncing: 'Content downloaden {done}/{total}',
    offline: 'Offline — speelt door vanuit de cache',
    webBlockedTitle: 'Deze website kan niet in een frame worden getoond',
    weatherUnavailable: 'Weer niet beschikbaar',
    today: 'Vandaag',
    days: '{n} dagen',
    tomorrow: 'Morgen',
    birthday: 'Jarig',
    countdownDone: 'Het is zover!',
    nowServing: 'Nu aan de beurt',
    counter: 'Balie',
    demoBadge: 'Live demo',
    feedUnavailable: 'Nieuws tijdelijk niet beschikbaar',
  },
  en: {
    pairTitle: 'Pair this screen',
    pairStep1: 'In the TB-cast portal, go to Screens → Add screen',
    pairStep2: 'Enter this code or scan the QR code',
    pairExpires: 'Code expires in {min} min',
    pairPaired: 'Paired! Loading content…',
    pairOffline: 'No internet connection. Retrying…',
    licenseTitle: 'License expired',
    licenseText: 'Please contact your administrator.',
    licenseUnlicensed: 'This screen has no active license.',
    noContent: 'No content assigned yet',
    noContentText: 'Assign a playlist, layout or schedule to this screen in the portal.',
    loading: 'Loading content…',
    syncing: 'Downloading content {done}/{total}',
    offline: 'Offline — playing from cache',
    webBlockedTitle: 'This website cannot be shown in a frame',
    weatherUnavailable: 'Weather unavailable',
    today: 'Today',
    days: '{n} days',
    tomorrow: 'Tomorrow',
    birthday: 'Birthday',
    countdownDone: "It's time!",
    nowServing: 'Now serving',
    counter: 'Desk',
    demoBadge: 'Live demo',
    feedUnavailable: 'News temporarily unavailable',
  },
} as const;

export type StringKey = keyof (typeof strings)['nl'];

export function t(
  locale: string,
  key: StringKey,
  vars: Record<string, string | number> = {},
): string {
  const table = locale === 'en' ? strings.en : strings.nl;
  return table[key].replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ''));
}

export function browserLocale(): 'nl' | 'en' {
  return navigator.language?.toLowerCase().startsWith('nl') ? 'nl' : 'en';
}
